'use strict';

var _ = require('lodash');
var FlightMarketMixGraphAggregationFactory = function FlightMarketMixGraphAggregationFactory(DataAggregationFactory, ExtractMetricKeysService) {
  function FlightMarketMixGraphAggregation() {
    DataAggregationFactory.call(this, ['service'], 'market-mix-graph');
  }
  FlightMarketMixGraphAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  FlightMarketMixGraphAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.targetType === targetType && this.sourceType.indexOf(sourceType) > -1;
  };
  FlightMarketMixGraphAggregation.constructor = FlightMarketMixGraphAggregation;
  FlightMarketMixGraphAggregation.prototype.reduceEntries = function (group, keys, reducedEntry) {
    var value, aggregatedValue, valueIndex, valueLength, keysIndex, keysLength, index;
    for (var groupindex = 0, groupLength = group.length; groupindex < groupLength; groupindex++) {
      for (keysIndex = 0, keysLength = keys.length; keysIndex < keysLength; keysIndex++) {
        value = group[groupindex][keys[keysIndex]];
        aggregatedValue = reducedEntry[keys[keysIndex]];
        if (Array.isArray(value)) {
          if (!aggregatedValue) {
            reducedEntry[keys[keysIndex]] = [];
          }
          for (valueIndex = 0, valueLength = value.length; valueIndex < valueLength; valueIndex++) {
            if (!_.isUndefined(value[valueIndex])) {
              reducedEntry[keys[keysIndex]][valueIndex] = (aggregatedValue && aggregatedValue[valueIndex] ? aggregatedValue[valueIndex] : 0) + value[valueIndex];
            }
          }
        } else if (!_.isUndefined(value)) {
          reducedEntry[keys[keysIndex]] = (aggregatedValue ? aggregatedValue : 0) + value;
        }
      }
    }
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      if (Array.isArray(reducedEntry[keys[index]])) {
        if (reducedEntry[keys[index]][1] === undefined) {
          reducedEntry[keys[index]] = undefined;
        } else if (reducedEntry[keys[index]][1] !== 0) {
          reducedEntry[keys[index]] = reducedEntry[keys[index]][0] / reducedEntry[keys[index]][1];
        } else {
          reducedEntry[keys[index]] = 0;
        }
      }
    }
  };
  FlightMarketMixGraphAggregation.prototype.aggregate = function (data) {
    var aggregatedMarkets = {},
      keys,
      keysLength,
      metricKeys,
      aggregatedMarketsLength,
      aggregatedMarketsArray = [];
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      if (Array.isArray(aggregatedMarkets[data[index].market])) {
        aggregatedMarkets[data[index].market].push(data[index]);
      } else {
        aggregatedMarkets[data[index].market] = [data[index]];
      }
    }
    keys = Object.keys(aggregatedMarkets);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      var reducedEntry = {},
        group = keys[index];
      reducedEntry.totalBooking = 0;
      for (var groupIndex = 0, groupLength = aggregatedMarkets[group].length; groupIndex < groupLength; groupIndex++) {
        reducedEntry.totalBooking = reducedEntry.totalBooking + (aggregatedMarkets[group][groupIndex].bookingsCurrent || 0);
      }
      reducedEntry.group = aggregatedMarkets[group];
      reducedEntry.label = group;
      aggregatedMarketsArray[index] = reducedEntry;
    }
    aggregatedMarkets = aggregatedMarketsArray;
    for (index = 0, aggregatedMarketsLength = aggregatedMarkets.length; index < aggregatedMarketsLength; index++) {
      var element = aggregatedMarkets[index];
      var elementGroup = element.group;
      element.group = null;
      element.departureDate = elementGroup[0].departureDate;
      metricKeys = ExtractMetricKeysService.extract(elementGroup[0]);
      this.reduceEntries(elementGroup, metricKeys, element);
    }
    aggregatedMarkets.sort(function (first, second) {
      if (second.totalBooking === first.totalBooking) {
        return second.m2 - first.m2;
      } else {
        return second.totalBooking - first.totalBooking;
      }
    });
    return aggregatedMarkets;
  };
  return FlightMarketMixGraphAggregation;
};
FlightMarketMixGraphAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = FlightMarketMixGraphAggregationFactory;